import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getCharts = async () => {
  try {
    const response = await api.get('/charts', {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Erro ao buscar detalhes dos gráficos.'
    );
  }
};